import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class DockAppointments_ds_get_dock_appointment_by_orderId_appointmentIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { orderId: number, dockAppointmentId: number }): 
  Promise<{ result: { Id?: number, DockAppointmentId?: number, ItemEntityId?: number, ItemEntityType?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil(inParams.dockAppointmentId)) {
      missingRequiredInParams.push('\'dockAppointmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_get_dock_appointment_by_orderId_appointmentId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { orderId: number, dockAppointmentId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, DockAppointmentId?: number, ItemEntityId?: number, ItemEntityType?: string }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil(inParams.dockAppointmentId)) {
      missingRequiredInParams.push('\'dockAppointmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_get_dock_appointment_by_orderId_appointmentId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { orderId: number, dockAppointmentId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, DockAppointmentId?: number, ItemEntityId?: number, ItemEntityType?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil(inParams.dockAppointmentId)) {
      missingRequiredInParams.push('\'dockAppointmentId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_get_dock_appointment_by_orderId_appointmentId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      orderId: number, dockAppointmentId: number    }) {
        if(isNil(inParams.orderId)) {
          return true; 
        }
        if(isNil(inParams.dockAppointmentId)) {
          return true; 
        }
      return false;
    }
}
